const exportDataHandlingStrategies = {

  GENERATE_SPREADSHEET_LOCALLY: 1,
  GENERATE_SPREADSHEET_SERVER_SIDE: 2
};

export default exportDataHandlingStrategies;